import React from 'react';

import classes from './InbodyIndicatorsChartView.module.scss';
import { InfoBox } from '../../../../../../../shared/components/ui-components';
import { InbodyIndicatorInfo } from '../../../../../../interfaces/inbodyIndicator';
import { getRoundedNumber } from '../../../../../../../shared/utils/mathUtils';
import { INBODY_INDICATORS_KEY } from '../../../../../../constants/inbodyIndecatorsKey';
import { MealPlanOnScanDayInfo } from '../../../../../../interfaces/mealPlanOnScanDayInfo';
import { InbodyType } from '../../../../../../../shared/constants/inbody-info/InbodyType';
import { Flags } from '../../../../../../../utils-types';
import { getDataLabels } from './utils/getDataLabels';
import { ShortListChart } from './ShortListChart/ShortListChart';
import { LongListChart } from './LongListChart/LongListChart';

type InbodyIndicatorsChartViewProps = {
  customerInbodyIndicators: InbodyIndicatorInfo[];
  mealPlansOnScanDay: MealPlanOnScanDayInfo[];
  customerInbodyTypeFlags: Flags<InbodyType>;
};

const InbodyIndicatorsChartView = ({
  customerInbodyIndicators,
  mealPlansOnScanDay,
  customerInbodyTypeFlags,
}: InbodyIndicatorsChartViewProps) => {
  return customerInbodyIndicators.map(({ label, measurement, key, scans }) => {
    const labels = getDataLabels({
      scans,
      indicatorKey: key,
      mealPlansOnScanDay,
      customerInbodyTypeFlags,
    });

    const values = scans.map(({ value }) => {
      if (key === INBODY_INDICATORS_KEY.ECW_TBW) {
        return value;
      }

      return getRoundedNumber(value, 1);
    });

    const chartHeight = key === INBODY_INDICATORS_KEY.WEIGHT ? 330 : 272;

    const chartTitle = measurement ? `${label} (${measurement})` : label;

    return (
      <InfoBox title={chartTitle} key={key} customContentPadding>
        <div className={classes.chartContainer} style={{ height: chartHeight }}>
          {scans.length > 16 ? (
            <LongListChart labels={labels} values={values} />
          ) : (
            <ShortListChart labels={labels} values={values} />
          )}
        </div>
      </InfoBox>
    );
  });
};

export { InbodyIndicatorsChartView };
